
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CartProductBillingItemsTaxGrid extends Serenity.EntityGrid<CartProductBillingItemsTaxRow, any> {
        protected getColumnsKey() { return CartProductBillingItemsTaxColumns.columnsKey; }
        protected getDialogType() { return CartProductBillingItemsTaxDialog; }
        protected getIdProperty() { return CartProductBillingItemsTaxRow.idProperty; }
        protected getInsertPermission() { return CartProductBillingItemsTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return CartProductBillingItemsTaxRow.localTextPrefix; }
        protected getService() { return CartProductBillingItemsTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}